namespace appn.views.taskTemplates.index {

    class InitArgs {
        organiseTaskTemplates: string = emptyString;
        dateFilter: string = emptyString;
        taskTemplatesIndex: string = emptyString;
        taskTemplatesSettings: string = emptyString;
    }

    let _initArgs: InitArgs;
    let _dataTable: any;

    export function init(args: InitArgs): void {
        _initArgs = args;

        appn.folderFilter.init(_initArgs.taskTemplatesIndex);
        appn.dateFilter.init(_initArgs.dateFilter);
        createDataTable();
    }

    function createDataTable() {
        _dataTable = appn.dataTable.create('.dataTable', {
            sDom: appn.dataTable.genSDom(1, 0, 4),
            sAjaxSource: 'TaskTemplates/DataTable',
            fnServerData: function(data: any) {
                data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').prop('checked')),
                    { name: 'sCustom_1', value: appn.folderFilter.getStateOrDefault().value },
                    { name: 'sCustom_2', value: appn.dateFilter.getStateOrDefaultAsString() });
            },
            aaSorting: [[1, 'asc']],
            aoColumns: [
                { bSortable: false, sWidth: '3%' },
                { bSortable: true, sWidth: '50%' },
                { bSortable: true, sWidth: '20%' },
                { bSortable: true, sWidth: '25%' }
            ],
            fnInitComplete: function() {
                // Inject Screen Action buttons
                appn.actionButtons.renderNavbarActionButtons([
                    { buttonId: 'organiseBtn', buttonType: 'Organise', isDataTableToggleBtn: true },
                ], appn.requestUser.isUserOrHigher, true);

                appn.actionButtons.renderNavbarActionButtons([
                    { buttonId: 'addnew', buttonType: 'AddNew' }
                ], appn.requestUser.isUserOrHigher);

                $('#addnew').click(function(e) {
                    e.preventDefault();
                    appn.location.navTo(_initArgs.taskTemplatesSettings, [
                        { name: 'Id', value: appn.emptyGuid },
                        { name: 'folderId', value: appn.folderFilter.selectedFolderId }
                    ]);
                });

                // Prepend the show button
                appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));

                // Bind organise button
                $('#organiseBtn').click(function() {
                    appn.folderFilter.showDialog($(this), _initArgs.organiseTaskTemplates);
                });

                appn.dataTable.addSearchPlaceholder(T('Filter results where Task Template <b>Name, User First Name, Last Name or External Id</b> contains a keyword typed in here.'));

                appn.saveMeState.init(function() {
                    _dataTable.fnDraw(false);
                },
                    function() {
                        _dataTable.fnDraw(false);
                    }, '.dataTables_filter');
            }
        });

    }
}
